import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getWorkoutsVideos } from '../../actions';


class WorkoutsVideos extends Component {

  initState = {
    search: [],
  }

  state = {
    ...this.initState,
    videosAll: [],
    videos: [],
  }

  componentWillMount = () => {
    this.props.getWorkoutsVideos()
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.videos) {
      this.setState({
        videosAll: nextProps.videos,
        videos: nextProps.videos,
      })
    } 
  }

  handleChange = (evt) => {
    const name = evt.target.name;
    let value = evt.target.value;
    
    this.setState({
      [name]: value
    });

    if(name === 'search') {
      this.setState({
        videos: this.state.workoutsAll.filter(workout => workout && workout.name && workout.level.includes(value))
      })
    }

  }

  renderVideos = () => (
    this.state.videos ? 
    this.state.videos.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)).map((video, i) => {
      return <div key={i} className="video-div">
        <div className="videos-details">
          <p className="video-name">{ video.name}</p>
          <p className="video-level">{ video.level}</p>
        </div>
        <div className="video-img-div">
        <video controls width="250" className={ video.trainer_name.includes("Lior") ? "video-img" : "video-img video-img-old"}>
          <source src={video.url}
                  type="video/mp4"/>

          Sorry, your browser doesn't support embedded videos.
          </video>
        </div>
      </div>
    }) : null
  )

  render() {
    return (
      <div>
        <div className="">
          <h2>Videos</h2>
          <div>
          {
            this.renderVideos()
          }
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    videos: state.workout.videos
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getWorkoutsVideos },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkoutsVideos);